import { FiX } from "react-icons/fi";
import classes from "./ViewProductModal.module.css";

export default function ViewProductModal({ product, onClose, getImageUrl }) {
  if (!product) return null;

  // Parse gallery safely
  const gallery = (() => {
    try {
      const g =
        typeof product.productGallery === "string"
          ? JSON.parse(product.productGallery)
          : product.productGallery;
      return Array.isArray(g) ? g : [];
    } catch {
      return [];
    }
  })();

  return (
    <div className={classes.modalOverlay} role="dialog" aria-modal="true">
      <div className={classes.modal}>
        <header className={classes.modalHeader}>
          <h3 className={classes.title}>Product Details</h3>
          <button className={classes.closeBtn} onClick={onClose}>
            <FiX />
          </button>
        </header>

        <div className={classes.content}>
          <div className={classes.imageRow}>
            <div className={classes.imageWrapper}>
              <img
                src={getImageUrl(product.productImage)}
                alt={product.productName}
                onError={(e) => (e.target.src = getImageUrl())}
              />
            </div>
          </div>

          <div className={classes.detailsRow}>
            <div className={classes.detailsGrid}>
              <div className={classes.formGroup}>
                <label>Product Name</label>
                <input type="text" value={product.productName} readOnly />
              </div>

              <div className={classes.formGroup}>
                <label>SKU</label>
                <input type="text" value={product.sku || "-"} readOnly />
              </div>

              <div className={classes.formGroup}>
                <label>Brand</label>
                <select disabled>
                  <option>{product.brandName || "—"}</option>
                </select>
              </div>

              <div className={classes.formGroup}>
                <label>Category</label>
                <select disabled>
                  <option>{product.categoryName || "—"}</option>
                </select>
              </div>

              <div className={classes.formGroup}>
                <label>Status</label>
                <input
                  type="text"
                  value={(product.status || "draft").toUpperCase()}
                  readOnly
                />
              </div>

              <div className={classes.formGroup}>
                <label>Condition</label>
                <select disabled>
                  <option>{product.condition || "—"}</option>
                </select>
              </div>

              <div className={classes.formGroup}>
                <label>Regular Price</label>
                <input
                  type="text"
                  value={product.regularPrice || "0"}
                  readOnly
                />
              </div>

              <div className={classes.formGroup}>
                <label>Sales Price</label>
                <input
                  type="text"
                  value={
                    product.salePrice && parseFloat(product.salePrice) > 0
                      ? product.salePrice
                      : "N/A"
                  }
                  readOnly
                />
              </div>

              <div className={classes.formGroup}>
                <label>Availability</label>
                <input
                  type="text"
                  value={product.availability || "—"}
                  readOnly
                />
              </div>

              <div className={classes.formGroup}>
                <label>Stocks</label>
                <input type="text" value={product.inStock ?? "0"} readOnly />
              </div>

              <div className={classes.formGroup}>
                <label>Short Description</label>
                <textarea value={product.productShortDesc || "—"} readOnly />
              </div>

              <div className={classes.formGroup}>
                <label>Description</label>
                <textarea value={product.productDesc || "—"} readOnly />
              </div>

              <div className={classes.formGroup}>
                <label>Meta Title</label>
                <input type="text" value={product.metaTitle || "—"} readOnly />
              </div>

              <div className={classes.formGroup}>
                <label>Meta Description</label>
                <textarea value={product.metaDescription || "—"} readOnly />
              </div>
            </div>
          </div>

          {gallery.length > 0 && (
            <div className={classes.galleryRow}>
              <h4>Gallery</h4>
              <div className={classes.gallery}>
                {gallery.map((img, i) => (
                  <div key={i} className={classes.galleryItem}>
                    <img
                      src={getImageUrl(img)}
                      alt={`gallery-${i}`}
                      onError={(e) => (e.target.src = getImageUrl())}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <footer className={classes.modalFooter}>
          <button className={classes.closeBtnSecondary} onClick={onClose}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}
